export default {
    data: {
        "product_codes":
            [
                "claimsumfest1",
                "claimsumfest2",
                "claimsumfest3",
                "claimsumfest4",
                "claimsumfest5",
                "claimsumfest6",
                "claimsumfest7",
                "claimsumfest8",
                "claimsumfest9",
                "claimsumfest10",
                "claimsumfest11",
                "claimsumfest12",
                "claimsumfest13",
                "claimsumfest14",
                "claimsumfest15",
                "claimsumfest16",
                "claimsumfest17",
                "claimsumfest18"
            ], "language": "ru", "etag": new Date().getTime()
    }
};